import React from 'react';
import { Alert } from '../alerts';
import { get } from 'global/lib/lodash';

export default (props) => {
  const { error } = props;

  if (!error) {
    return null;
  }

  return (
    <div style={{ margin: 8 }}>
      <Alert severity={get(props, 'severity', 'error')}>{`Error: ${get(error, 'message', '')}`}</Alert>
    </div>
  );
};
